import { isValidId } from './isValidId.js';
import { base } from './base.js';

/**
 * Response
 * @url http://www.jsonrpc.org/specification#response_object
 * @constructor
 * @param {*} result - The result of the request invocation
 * @param {JsonRpcError} error - Any error that might have occurred during the request invocation
 * @param {Number|String} id - The request ID
 */
function JsonRpcResponse(result, error, id) {
    if (!(this instanceof JsonRpcResponse)) {
        // @ts-ignore
        return new JsonRpcResponse(result, error, id);
    }
    if (!isValidId(id)) {
        throw new TypeError('Response id must be a non-empty string or a number');
    }
    base(this);
    if (error) {
        this.error = error;
    }
    else {
        this.result = result;
    }
    this.id = id;
}

export { JsonRpcResponse };
